module.exports = "/_next/static/images/device-color-board@2x-min-cc973ab6993810504b4bd4b9ada5e9b8.png.webp";